import React, {useEffect, useMemo, useRef, useState} from 'react'
import {getFormattedDate, getFormattedTime} from 'utils/helper'
import {useHotkeys} from 'react-hotkeys-hook'
import {INBOX_KEYBOARD_SHORTCUTS} from 'constants/keyboard-shortcuts'
import ConversationMsgBox from './ConversationMsgBox'
import Note from './Note'

const EmailBodyContent = props => {
  const {
    conversationMessages,
    replyEditorRef,
    MessagesId,
    noteToMessage,
    FromMailId,
    mailbox,
    conversationType,
    conversationSubject,
    conversationId,
    printReference,
  } = props

  const conversationMessagesReverse = useMemo(() => {
    const messages = [...conversationMessages]
    return messages.reverse()
  }, [conversationMessages])

  const itemRefs = useRef([])

  const [lastItemsRef, setLastItemsRef] = useState(null)

  useEffect(() => {
    if (conversationMessagesReverse.length > 0) {
      setLastItemsRef(itemRefs.current[conversationMessagesReverse.length - 1])
    } else {
      setLastItemsRef(null)
    }
  }, [conversationMessagesReverse])

  useHotkeys(
    INBOX_KEYBOARD_SHORTCUTS.REPLY_CONV.key,
    () => lastItemsRef && lastItemsRef.querySelector('button[data-btn="reply"]').click(),
    [lastItemsRef]
  )

  useHotkeys(
    INBOX_KEYBOARD_SHORTCUTS.FORWRD_CONV.key,
    () => lastItemsRef && lastItemsRef.querySelector('button[data-btn="forward"]').click(),
    [lastItemsRef]
  )

  useHotkeys(
    INBOX_KEYBOARD_SHORTCUTS.REPLY_WITH_AI_CONV.key,
    () => lastItemsRef && lastItemsRef.querySelector('button[data-btn="reply-with-ai"]').click(),
    [lastItemsRef]
  )

  return (
    <div ref={printReference}>
      {conversationMessagesReverse.map((msg, i) => {
        return (
          <React.Fragment key={msg.id}>
            <ConversationMsgBox
              conversationMessagesReverse={conversationMessagesReverse}
              index={i}
              conversationType={conversationType}
              FromMailId={FromMailId}
              messageId={msg.id}
              replyEditorRef={replyEditorRef}
              to={msg.to}
              isInbound={msg.isInbound}
              date={getFormattedDate(msg.updatedAt || msg.createdAt)}
              dateAndTime={`${getFormattedDate(msg.updatedAt || msg.createdAt)} ${getFormattedTime(
                msg.updatedAt || msg.createdAt
              )}`}
              textHtml={msg.messageHtml}
              mailbox={mailbox}
              fromObj={Array.isArray(msg.from) ? msg.from : []}
              isDraft={msg.isDraft}
              attachments={msg.attachments ? msg.attachments : []}
              conversationId={conversationId}
              singleMsgData={msg}
              conversationSubject={conversationSubject}
              ref={el => (itemRefs.current[i] = el)}
            />
            <Note msg={msg} actionId={msg.id} MessagesId={MessagesId} noteToMessage={noteToMessage} />
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default EmailBodyContent
